import api from '../utils/api';

// Fetch all Borrow Records
export const getBorrowRecords = async (headers) => {
  try {
    const response = await api.get('/api/borrow-records/borrow-records', headers);
    console.log(" getBorrowRecords ", response.data)
    return response.data;
  } catch (error) {
    console.error('Error fetching borrow records:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch a specific Borrow Record by ID
export const getBorrowRecordById = async (id, headers) => {
  try {
    const response = await api.get(`/api/borrow-records/borrow-records/${id}`, headers);
    return response.data;
  } catch (error) {
    console.error(`Error fetching borrow record with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Create a new Borrow Record
export const createBorrowRecord = async (borrowRecordData, headers) => {
  try {
    const response = await api.post('/api/borrow-records/borrow-records', borrowRecordData, headers);
    return response.data;
  } catch (error) {
    console.error('Error creating borrow record:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Update an existing Borrow Record
export const updateBorrowRecord = async (id, borrowRecordData, headers) => {
  try {
    const response = await api.put(`/api/borrow-records/borrow-records/${id}`, borrowRecordData, headers);
    return response.data;
  } catch (error) {
    console.error(`Error updating borrow record with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Delete a Borrow Record
export const deleteBorrowRecord = async (id, headers) => {
  try {
    const response = await api.delete(`/api/borrow-records/borrow-records/${id}`, headers);
    return response.data;
  } catch (error) {
    console.error(`Error deleting borrow record with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};
